import { services } from 'services/base';
import { getMainConfig } from 'utils';

const initProfileMenuServices = () => {
  const profileMenu = getMainConfig('profileMenu') || [];

  services.registerCollection('appFrame.profileMenu', profileMenu);
};

export default initProfileMenuServices;
